/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type GIF_MEDIA_SOURCE = "GIPHY" | "TENOR" | "%future added value";
export type MediaSectionContainer_settings = {
    readonly media: {
        readonly twitter: {
            readonly enabled: boolean;
        };
        readonly bluesky: {
            readonly enabled: boolean;
        };
        readonly youtube: {
            readonly enabled: boolean;
        };
        readonly gifs: {
            readonly enabled: boolean;
            readonly provider: GIF_MEDIA_SOURCE | null;
        };
        readonly external: {
            readonly enabled: boolean;
        };
    };
    readonly " $refType": "MediaSectionContainer_settings";
};
export type MediaSectionContainer_settings$data = MediaSectionContainer_settings;
export type MediaSectionContainer_settings$key = {
    readonly " $data"?: MediaSectionContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"MediaSectionContainer_settings">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v1 = [
        (v0 /*: any*/)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "MediaSectionContainer_settings",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TwitterMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "twitter",
                        "plural": false,
                        "selections": (v1 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "BlueskyMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "bluesky",
                        "plural": false,
                        "selections": (v1 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "YouTubeMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "youtube",
                        "plural": false,
                        "selections": (v1 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "GifMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "gifs",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "provider",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "external",
                        "plural": false,
                        "selections": (v1 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Settings",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '78ead7d642c7ededa3a31d1c5da9aeca';
export default node;
